/**
 * Store-shell Product QA (`/app/store/staged-products`).
 *
 * Motzu admins already have `/app/admin/staged-products`. Impersonation is
 * org-level and must not inherit that access into a store that was never
 * granted `productQaEnabled`.
 */
export function hasStoreProductQaAccess(input: {
  isImpersonating: boolean;
  productQaEnabled?: boolean | null;
}): boolean {
  if (input.isImpersonating) return false;
  return input.productQaEnabled === true;
}
